import { differenceInCalendarDays, dateFromString } from 'lib/date';

export const getNumNights = (checkIn, checkOut) => differenceInCalendarDays(dateFromString(checkOut), dateFromString(checkIn));
